<template>
<section class="apk-info">
  <h2 class="apk-info__title">Secure VPN APK Information</h2>
  <div class="apk-info__table-wrap">
    <table class="apk-info__table">
      <tbody>
        <tr v-for="row in rows" :key="row.label">
          <th scope="row">{{ row.label }}</th>
          <td>{{ row.value }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</section>
</template>

<script>
export default {
  name: 'ApkInfoSection',
  data() {
    return {
      rows: [
        { label: 'App Name:', value: 'Secure VPN' },
        { label: 'Latest Version:', value: 'Latest Version' },
        { label: 'File Size:', value: '22MB' },
        { label: 'Requirement:', value: 'Android 5.0+' },
        { label: 'Category:', value: 'VPN & Security' },
        { label: 'License:', value: 'Free' },
        { label: 'Ads:', value: 'No Ads' },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
.apk-info {
  padding: 24px 28px 28px;
  border-radius: 18px;
  border: 1px solid var(--vpn-line, #e8e4f8);
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.96) 0%, rgba(245, 241, 255, 0.98) 100%);
  box-shadow: 0 12px 32px rgba(109, 74, 255, 0.06);
  box-sizing: border-box;
}

.apk-info__title {
  margin: 0 0 18px;
  text-align: left;
  font-size: clamp(24px, 2.8vw, 32px);
  line-height: 1.2;
  letter-spacing: -0.02em;
  color: var(--vpn-ink, #1f2430);
  font-weight: 800;
}

.apk-info__table-wrap {
  width: 100%;
  overflow-x: auto;
  border-radius: 10px;
  border: 1px solid var(--vpn-line, #e8e4f8);
  background: #fff;
  box-shadow: none;
}

.apk-info__table {
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    padding: 10px 22px;
    text-align: left;
    font-size: 15px;
    line-height: 1.35;
    border-bottom: 1px solid var(--vpn-line, #e8e4f8);
  }

  th {
    width: 230px;
    font-weight: 700;
    color: var(--vpn-ink, #1f2430);
    background: rgba(109, 74, 255, 0.06);
  }

  td {
    color: var(--vpn-ink-muted, #5b6475);
  }

  tr:last-child th,
  tr:last-child td {
    border-bottom: 0;
  }
}

@media (max-width: 768px) {
  .apk-info {
    padding: 18px 14px 20px;
    border-radius: 16px;
  }

  .apk-info__title {
    margin-bottom: 14px;
    font-size: clamp(20px, 5.5vw, 26px);
  }

  .apk-info__table {
    th,
    td {
      display: block;
      width: 100%;
      min-width: 0;
      padding: 8px 14px;
    }

    th {
      padding-bottom: 2px;
      border-bottom: 0;
      background: rgba(109, 74, 255, 0.06);
    }

    td {
      padding-top: 2px;
      padding-bottom: 12px;
    }

    tr {
      border-bottom: 1px solid var(--vpn-line, #e8e4f8);
    }

    tr:last-child {
      border-bottom: 0;

      td {
        padding-bottom: 10px;
      }
    }
  }
}
</style>
